import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactPlayer from 'react-player'
import Form from "./Form"
import wpxpertise from '../../assets/icons/support/logo.png'
import supportagent from '../../assets/icons/support/supportagent.svg'
import orderStatus from '../../assets/order-status.gif'
import Modal from '../Components/Modal/Modal';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';

import Tippy from '@tippy.js/react';
import { isPro, getNoticeData } from '../Helpers';
import 'tippy.js/dist/tippy.css'
import "./fromstyle.scss";
import NoticeModal from '../Components/NoticeModal/NoticeModal';

const PluginList = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [pluginslist, setPluginslist] = useState([]);
  const [copySuccess, setCopySuccess] = useState('');

  const proData = isPro();

  // console.log(getNoticeData())

  const limit = 0.5 + 0.5 + 0.5 + 0.5;
  const allConditionsMet = proData;
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    type: 'confirmation',
    title: '',
    message: '',
    onConfirm: () => { },
    confirmText: 'Confirm',
    declineText: 'Cancel'
  });
  const closeModal = () => {
    setModalConfig(prev => ({ ...prev, isOpen: false }));
  };

  // Extract the last part of the URL as the site identifier
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const indexOfAdmin = pathParts.indexOf('wp-admin');
  const siteIdentifier = indexOfAdmin !== -1 ? pathParts.slice(indexOfAdmin - 1, indexOfAdmin).pop() : pathParts.slice(-1).pop();
  // Use the site identifier to create a unique localStorage key
  const localStorageKey = `wpnts_pluginslist_${siteIdentifier}`;
  //END ------------------

  // console.log(getNoticeData().wpnts_plugin_list);

  useEffect(() => {
    const wpnts_plugin_list_data = getNoticeData().wpnts_plugin_list;

    // Ensure wpnts_plugin_list_data is an array or use a default array
    const wpnts_plugin_list = Array.isArray(wpnts_plugin_list_data)
      ? wpnts_plugin_list_data
      : [
        {
          id: 1707213500663,
          title: "add-plugin-name",
          content: "Plugin-1",
        },
      ];

    const saveForm = localStorage.getItem(localStorageKey) || JSON.stringify(wpnts_plugin_list);

    // console.log(saveForm);

    try {
      const parsedForm = JSON.parse(saveForm);
      // Ensure parsedForm is an array
      if (Array.isArray(parsedForm)) {
        setPluginslist(parsedForm);
      } else {
        console.error('Invalid data format in localStorage:', parsedForm);
        setPluginslist([]);
      }
    } catch (error) {
      // Handle the error as needed
      console.error(error);
      setPluginslist([]);
    }
  }, []);





  const addContact = async e => {
    // setModalOpen(true)

    window.open('https://functiondeck.com/', '_blank');
  }
  const addSupport = async e => {
    window.open('https://wordpress.org/support/plugin/notifier-to-slack/', '_blank');
  }

  const addPlugin = async e => {
    if (pluginslist.length >= limit && !allConditionsMet) {
      setModalConfig({
        isOpen: true,
        type: 'premium',
        title: '🚀 Oops! This is a Premium Feature',
        message: 'Evaluate the features and select a bundle based on your needs.',
        onConfirm: () => {
          window.open('https://functiondeck.com/pricing/', '_blank');
          closeModal();
        },
        confirmText: 'Upgrade Now',
        declineText: 'Maybe Later'
      });
      return;
    }

    const newPlugin = {
      id: Date.now(),
      title: `Plugin- ${pluginslist.length + 1}`,
      content: `plugin name- ${pluginslist.length + 1}`
    };

    const updatePluginslist = [...pluginslist, newPlugin];
    setPluginslist(updatePluginslist);
    localStorage.setItem(localStorageKey, JSON.stringify(updatePluginslist));

    /**
     * Add new plugin list name 
     * 
     */
    const url = `${appLocalizer.wpntsUrl}/wpnts/v1/org_plugin_name`;
    try {
      const res = await axios.post(url, {
        updatePluginslist
      }, {
        headers: {
          'content-type': 'application/json',
          'X-WP-NONCE': appLocalizer.nonce
        }
      }).then(function (res) {
        // console.log(res)
        // console.log(updatePluginslist)
      });

    } catch (err) {
      // console.log(err);
    }

  };

  const deletePlugin = (id) => {
    const filteredPluginlist = pluginslist.filter(
      (pluginslist) => pluginslist.id !== id);
    setPluginslist(filteredPluginlist);
    localStorage.setItem(localStorageKey, JSON.stringify(filteredPluginlist));
  };


  // add plugin  
  const handleContentChange = (id, newContent) => {
    const updatePluginslist = pluginslist.map((plist) => {
      if (plist.id === id) {
        return { ...plist, content: newContent };
      } else {
        return plist;
      }
    });
    setPluginslist(updatePluginslist);
    localStorage.setItem(localStorageKey, JSON.stringify(updatePluginslist));
  };

  //save
  const handleSaveAll = (id, newContent) => {
    const updatePluginslist = pluginslist.map((plist) => {
      if (plist.id === id) {
        return { ...plist, content: newContent };
      } else {
        return plist;
      }
    });
    setPluginslist(updatePluginslist);
    localStorage.setItem(localStorageKey, JSON.stringify(updatePluginslist));


    /**
     * update plugin list name 
     * 
     */
    const url = `${appLocalizer.wpntsUrl}/wpnts/v1/org_plugin_name`;
    try {
      const res = axios.post(url, {
        updatePluginslist
      }, {
        headers: {
          'content-type': 'application/json',
          'X-WP-NONCE': appLocalizer.nonce
        }
      }).then(function (res) {
        // console.log(updatePluginslist)
      });

    } catch (err) {
      console.log(err);
    }


    setModalConfig({
      isOpen: true,
      type: 'toast',
      title: 'success!',
      message: 'Plugin name updated',
      position: 'top-right'
    });
    setTimeout(closeModal, 3000);

  };


  const currentURL = window.location.href;
  const home = currentURL.substring(0, currentURL.indexOf("/wp-admin/"));
  const copied_json = home + '/wp-json/wpnts/v1/plugin_corn_run'

  const handleCopyClick = () => {
    const textArea = document.createElement('textarea');
    textArea.value = copied_json;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    setCopySuccess('Copied to clipboard');
  };

  useEffect(() => {
    if (copySuccess) {
      const timer = setTimeout(() => {
        setCopySuccess('');
      }, 2000); // 3 seconds in milliseconds

      return () => {
        clearTimeout(timer);
      };
    }
  }, [copySuccess]);

  return (

    <div className="acb_add_mail" id="acb_add_mail">

      <div className="acb_mails_container">
        <div className="acb_top">
          <img className="wpnts_logo_footer" src={wpxpertise} alt="staff" onClick={addContact} />
          <div className="getsupport">
            <img className="wpnts_logo_footer_2" src={supportagent} alt="staff" onClick={addSupport} />
          </div>
          <h1 className="setting_panel"><ChecklistRtlIcon /> Plugin list</h1>

        </div>
        <div className="acb_bottom" id='acb_bottom'>
          <div className="acb_left">

            <div className="wpnts-form-list">
              <div className="wpntsbtn">
                <button className="wpnts-add-form" onClick={addPlugin}>
                  Add Plugin
                  <span className="wcs_tooltip_class">
                    <Tippy content="Add your desirable plugin slug e.g notifier-to-slack from WordPress ORG plugin page">
                      <span className="wcs_title"><HelpOutlineIcon className='wcs_tooltip_icon' /></span>
                    </Tippy>
                  </span>
                </button>

                <button className="wpnts-save-form" onClick={handleSaveAll}>Update</button>
              </div>
              {pluginslist.map((plist) => (
                <Form
                  id={plist.id}
                  key={plist.id}
                  title={plist.title}
                  content={plist.content}
                  onDelete={() => deletePlugin(plist.id)}
                  onContentChange={handleContentChange}
                />
              ))}
            </div>

          </div>
          <div className="acb_right">
            <div className="corn-link">
              <h1 className="setting_data">
                Visit: <a target="_blank" href="https://console.cron-job.org/jobs/create">cron job</a> and add below slug
              </h1>
              <p>Add the corn URL to execute event, even though your site has no traffic/visitors. Regardless of whether you are not active on your website, it will send you a response at your preferred interval.</p>
              <h4>Click to copy the API 👇🏼</h4>
              <div>
                <hr />
                <code onClick={handleCopyClick} style={{ cursor: 'pointer' }}>
                  {copied_json}
                </code>
                <hr />
              </div>
              <p> {copySuccess && <span style={{ color: 'green' }}>{copySuccess}</span>}</p>

              <div>
                <h4>GUIDE: Please complete below steps</h4>
                <ol>
                  <li>Create cronjob</li>
                  <li>Set Title</li>
                  <li>Paste the URL you copied from above</li>
                  <li>Add an execution schedule of 5-25 minutes, in accordance with the specified interval.</li>
                  <li>Disable: From <b>'Notify me when'</b> the cronjob will be disabled because of too many failures</li>
                  <li>Click CREATE. Also you can test before create by click 'TEST RUN'</li>
                </ol>

              </div>
            </div>

            <div className='wcs-player-wrapper'>
              <ReactPlayer
                className='wcs-react-player'
                url='https://youtu.be/_UT_xdLRPPY'
                width='100%'
                height='100%'
                controls={true}
                light={true}
                config={{
                  youtube: {
                    playerVars: {
                      modestbranding: 1,
                      showinfo: 0,
                    },
                  },
                }}
                iframe
              />
            </div>

          </div>
        </div>
      </div>
      {modalOpen && <><div class="wcs_popup_overlay"></div> <Modal setOpenModal={setModalOpen} /> </>}
      <NoticeModal
        isOpen={modalConfig.isOpen}
        onClose={closeModal}
        onConfirm={modalConfig.onConfirm}
        onDecline={closeModal}
        type={modalConfig.type}
        title={modalConfig.title}
        message={modalConfig.message}
        confirmText={modalConfig.confirmText}
        declineText={modalConfig.declineText}
        position={modalConfig.position || 'center'}
        autoClose={modalConfig.type === 'toast'}
        autoCloseTime={3000}
      />
    </div>

  )
}

export default PluginList
